module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('popup', {
    staticClass: "secondary-wrapper",
    attrs: {
      "has_header": true,
      "show": _vm.show
    },
    on: {
      "close": _vm.closeBox,
      "on-shown": _vm.onShown
    }
  }, [_c('div', {
    staticClass: "secondary-body",
    attrs: {
      "slot": "popup-body"
    },
    slot: "popup-body"
  }, [_c('div', {
    staticClass: "title"
  }, [(!_vm.isReset) ? _c('h2', [_vm._v("二级密码登录")]) : _c('h2', [_vm._v("重置二级密码")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReset),
      expression: "!isReset"
    }],
    staticClass: "content"
  }, [_c('p', {
    staticClass: "content-text"
  }, [_vm._v("你的帐号设置了“二级密码”，请输入正确的密码登录 S-mart")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.localShow),
      expression: "localShow"
    }],
    staticClass: "content-input",
    attrs: {
      "type": "password",
      "name": "",
      "value": "",
      "placeholder": "请输入二级密码"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitSecondary.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "content-button",
    on: {
      "click": _vm.submitSecondary
    }
  }, [_vm._v("\n          提交\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-footer",
    on: {
      "click": _vm.forgetPwd
    }
  }, [_vm._v("\n          忘记密码？\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isReset),
      expression: "isReset"
    }],
    staticClass: "content reset"
  }, [_c('p', {
    staticClass: "content-text"
  }, [_vm._v("该操作将重置你的二级密码，请选择以下任意一种接收方式！")]), _vm._v(" "), _c('div', {
    staticClass: "content-btn-group"
  }, [_c('a', {
    staticClass: "btn-item",
    class: {
      'active': _vm.resetType == 'phone' && _vm.hasPhone,
      'hastip': !_vm.hasPhone
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setResetType('phone')
      }
    }
  }, [_vm._v("\n            手机短信"), (!_vm.hasPhone) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("您还未绑定手机")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "btn-item",
    class: {
      'active': _vm.resetType == 'email',
      'hastip': !_vm.hasEmail
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setResetType('email')
      }
    }
  }, [_vm._v("\n            电子邮箱"), (!_vm.hasEmail) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("您还未绑定邮箱")]) : _vm._e()])]), _vm._v(" "), (_vm.sendSuccess) ? _c('p', {
    staticClass: "content-info"
  }, [_vm._v("\n          " + _vm._s(_vm.tipText) + "发送成功，请查收\n        ")]) : _vm._e(), _vm._v(" "), (_vm.count.current == _vm.count.countDuring) ? _c('div', {
    staticClass: "content-button reset",
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v("\n          立即重置\n        ")]) : _c('div', {
    staticClass: "content-button reset wait"
  }, [_vm._v("\n          " + _vm._s(_vm.count.current) + "s后重新发送\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-footer",
    on: {
      "click": function($event) {
        _vm.isReset = false
      }
    }
  }, [_vm._v("\n          返回\n        ")])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4ceea7b0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/secondary.vue
// module id = F8Iy
// module chunks = 16